import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { AlertCircle } from 'lucide-vue-next';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InvoiceStatus',
    props: {
        status: { type: [String, Object], required: true },
        variant: { type: String, required: false, default: 'icon' }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        // Ensures status fallback resolves strictly to one of the 3 allowed statuses
        const status = computed(() => {
            const val = props.status?.toLowerCase();
            if (val === 'paid' || val === 'overdue')
                return val;
            return 'open';
        });
        const __returned__ = { props, status, get AlertCircle() { return AlertCircle; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
